import { render, staticRenderFns } from "./LogsTodoByRelations.vue?vue&type=template&id=6b526889&"
import script from "./LogsTodoByRelations.vue?vue&type=script&lang=js&"
export * from "./LogsTodoByRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports